import React from 'react';
import { useTranslation } from 'react-i18next';
import manavImg from '@/assets/image/Manav-Subodh.png';
import elizabethImg from '@/assets/image/Elizabeth-Saunders.png';
import ireneImg from '@/assets/image/Irene-Manning.png';
import saffinImg from '@/assets/image/Saffin-Mathew.png';
import parthImg from '@/assets/image/parth.jpeg';

interface MentorConfig {
  key: string;
  image: string;
}

const mentorConfigs: MentorConfig[] = [
  { key: 'manav', image: manavImg },
  { key: 'elizabeth', image: elizabethImg },
  { key: 'saffin', image: saffinImg },
  { key: 'parth', image: parthImg },
  { key: 'irene', image: ireneImg },

];

const MentorsAndAdvisors: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <section className="py-20 relative bg-gradient-to-r from-[#442c5f] via-[#c25969] to-[#f67c69] overflow-hidden text-white">
      <div className="container mx-auto w-full px-4 max-w-7xl relative z-10">
        <div className="text-center mb-16">
          <p className="text-sm md:text-base mb-2 opacity-90 tracking-wider">
            {t('mentors.tag', 'Our Global')}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight uppercase">
            {t('mentors.title', 'Mentors and Advisors')}
          </h2>
        </div>

        {/* Grid layout displaying 5 columns in a single row on desktop web */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-10 max-w-6xl mx-auto justify-items-center">
          {mentorConfigs.map((mentor, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-36 h-36 sm:w-40 sm:h-40 md:w-44 md:h-44 rounded-full overflow-hidden mb-6 bg-white border-4 border-white shadow-lg flex items-center justify-center">
                <img
                  src={mentor.image}
                  alt={t(`mentors.list.${mentor.key}.name`)}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-2">
                {t(`mentors.list.${mentor.key}.name`)}
              </h3>
              <p className="text-xs md:text-sm font-medium opacity-90 leading-snug">
                {t(`mentors.list.${mentor.key}.title`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MentorsAndAdvisors;

